/**
 * UserRoleContext.js
 * 사용자 역할 관리 (User, Manager, Admin)
 * TODO: 실제 인증 시스템 연동 후 구현
 */

import React, { createContext, useContext, useState } from 'react';

const UserRoleContext = createContext();

export const useUserRole = () => {
  const context = useContext(UserRoleContext);
  if (!context) {
    throw new Error('useUserRole must be used within a UserRoleProvider');
  }
  return context;
};

export const UserRoleProvider = ({ children }) => {
  // 실제 인증 시스템에서 사용자 역할 가져오기
  // localStorage에서 가져오되, 로그인 상태 확인
  const [userRole, setUserRole] = useState(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!isLoggedIn) {
      return 'user'; // 로그인하지 않은 경우 기본값
    }
    const saved = localStorage.getItem('userRole');
    return saved || 'user'; // 로그인한 경우 저장된 역할 사용, 없으면 'user'
  });

  // 로그인 상태 변경 감지
  React.useEffect(() => {
    const handleStorageChange = () => {
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
      if (isLoggedIn) {
        const saved = localStorage.getItem('userRole');
        if (saved) {
          setUserRole(saved);
        }
      } else {
        setUserRole('user');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    // 같은 탭에서 localStorage 변경 감지
    const interval = setInterval(() => {
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
      const currentRole = localStorage.getItem('userRole') || 'user';
      if (isLoggedIn && currentRole !== userRole) {
        setUserRole(currentRole);
      } else if (!isLoggedIn && userRole !== 'user') {
        setUserRole('user');
      }
    }, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [userRole]);

  const isUser = userRole === 'user';
  const isManager = userRole === 'manager' || userRole === 'admin' || userRole === 'root';
  const isAdmin = userRole === 'admin' || userRole === 'root';
  const isRoot = userRole === 'root';

  const value = {
    userRole,
    setUserRole,
    isUser,
    isManager,
    isAdmin,
    isRoot,
  };

  return (
    <UserRoleContext.Provider value={value}>
      {children}
    </UserRoleContext.Provider>
  );
};

export default UserRoleContext;

